import { render, staticRenderFns } from "./ProductAdminPages.vue?vue&type=template&id=4f8b11b6&scoped=true"
import script from "./ProductAdminPages.vue?vue&type=script&lang=js"
export * from "./ProductAdminPages.vue?vue&type=script&lang=js"
import style0 from "./ProductAdminPages.vue?vue&type=style&index=0&id=4f8b11b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f8b11b6",
  null
  
)

export default component.exports